import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { TERMS } from '../data/legal';
import { FileText, ChevronLeft, AlertOctagon } from 'lucide-react';

export default function Terms() {
  const { lang } = useLanguage();
  return (
    <div className="container-app py-8 sm:py-12 max-w-3xl animate-fade-in-up" data-testid="terms-page">
      <Link to="/" className="inline-flex items-center text-sm text-ink-secondary hover:text-terracotta mb-6">
        <ChevronLeft size={16} /> {lang === 'zh' ? '返回首页' : 'Home'}
      </Link>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-2xl bg-terracotta-light flex items-center justify-center">
          <FileText size={18} className="text-terracotta" />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-ink">
          {lang === 'zh' ? TERMS.title_zh : TERMS.title_en}
        </h1>
      </div>
      <p className="text-xs text-ink-tertiary mb-6">
        {lang === 'zh' ? TERMS.effective_zh : TERMS.effective_en}
      </p>
      <p className="text-ink-secondary leading-relaxed mb-8">
        {lang === 'zh' ? TERMS.intro_zh : TERMS.intro_en}
      </p>

      {/* Highlighted non-diagnostic banner */}
      <div className="mb-6 p-5 bg-risk-redbg border-2 border-risk-red/30 rounded-2xl flex gap-3" data-testid="terms-disclaimer-banner">
        <AlertOctagon size={20} className="text-risk-red flex-shrink-0 mt-0.5" />
        <p className="text-sm text-risk-red leading-relaxed font-medium">
          {lang === 'zh'
            ? '本工具不是医疗诊断。如有发烧、红肿加剧、剧痛或宝宝精神差，请立刻就医。'
            : 'This tool is not a medical diagnosis. If you have fever, worsening redness, severe pain, or your baby seems unwell, seek medical care immediately.'}
        </p>
      </div>

      {TERMS.sections.map((s, i) => (
        <section key={i} className="card-base p-6 sm:p-8 mb-5" data-testid={`terms-section-${i}`}>
          <h2 className="font-heading text-lg font-semibold text-ink mb-4">
            {lang === 'zh' ? s.heading_zh : s.heading_en}
          </h2>
          <ul className="space-y-2">
            {(lang === 'zh' ? s.points_zh : s.points_en).map((p, j) => (
              <li key={j} className="flex gap-3 text-ink-secondary leading-relaxed text-sm">
                <span className="text-terracotta flex-shrink-0">•</span>
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}

      <p className="text-xs text-ink-tertiary mt-6">
        {lang === 'zh'
          ? '本条款为初版，将由本地律师审阅后定稿。'
          : 'This is an initial draft; final wording will be reviewed by local counsel.'}
      </p>
    </div>
  );
}
